
import Vue from 'vue';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Button,
} from 'element-ui';
import api from '@/api/match';
import tEditor from '@/components/Editor/editor.vue';
import myVditor from '@/components/Markdown/vditor.vue';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Button,
    myVditor,
  },
})

export default class thirdStep extends Vue {
  @Prop({
    required: false,
    default: '添加赛事内容',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  @Prop({
    required: false,
    default: 0,
  }) editType!: number;

  private toolbarOptions: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
    [{ background: [] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],
    [{ size: ['10px', false, '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px'] }],
    [{ font: ['serif', 'monospace', 'Microsoft YaHei'] }],
    [{ align: [] }],
    ['clean'],
    ['link', 'image'],
  ];

  private form: { stepPoints: string, cid?: string, stepPointsMarkdown: string } = {
    stepPoints: '',
    stepPointsMarkdown: '',
  };

  private rules: any = {
    stepPoints: [
      { required: true, message: '请填写章节内容', trigger: 'blur' },
    ],
  }

  private loading: boolean = false;

  public $refs!: {
    form: Form,
    tEditor: tEditor,
    myVditor: myVditor,
  };

  mounted() {
    this.form.cid = this.oldForm.cid;
    if (this.title.includes('修改')) {
      this.form.stepPoints = this.oldForm.stepPoints;
      this.form.stepPointsMarkdown = this.oldForm.stepPointsMarkdown;
    }
  }

  /**
   * @author liangyongmou
   * @desc  富文本编辑器内容改变事件
   * @param { content } 富文本编辑器内容
   */
  contentChange(stepPoints: string) {
    this.$set(this.form, 'stepPoints', stepPoints);
  }

  markdownContentValue() {
    if(!this.$refs.myVditor) return
    let markdownValue = this.$refs.myVditor.getMarkdownValue()
    if (this.editType === 1) {
      this.$set(this.form, 'stepPointsMarkdown', markdownValue || '');
    }
    if (this.editType === 2) {
      this.$set(this.form, 'stepPoints', markdownValue || '');
    }
  }

  /**
   * @author liangyongmou
   * @desc 添加/修改赛事内容
   * @param { string } title 标题
   */
  handleSubmit() {
    this.markdownContentValue();
    this.loading = true;
    let params:{ stepPoints?: string } = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        params = this.form;
      }
    });
    return params;
  }

  /**
   * @author liangyongmou
   * @desc 重置赛事内容
   * @param { boolean } close 是否关闭模态框
   * @param { boolean } refrsh 是否点击重置按钮
   */
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    if (this.title.includes('修改')) {
      this.$refs.tEditor.refresh();
      this.form = this.oldForm;
    } else this.$refs.tEditor.refresh();
  }

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
